<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.group_id == 1 || has_perm('view_register_export_invoice')
    "
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <!-- <b>{{ $t("registerExportInvoice.title") }}</b> -->
              <lte-button
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-plus"
                v-if="
                  (has_perm('create_register_export_invoice') ||
                    GET_ACCOUNT_DATA.group_id == 1) &&
                    this.onTabSelect === 0
                "
                @click="addNew($event)"
                >{{ $t("common.addnew") }}</lte-button
              >
              <lte-button
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-download"
                v-if="
                  has_perm('create_register_export_invoice') ||
                    GET_ACCOUNT_DATA.group_id == 1
                "
                @click="exportExcel($event)"
                >{{ $t("common.exportFileExcel") }}</lte-button
              >
            </div>
          </div>
          <div class="box-body">
            <!-- B-Table Start -->
            <b-table
              :items="gridDataList"
              :fields="gridColumns"
              class="mt-3"
              outlined
              responsive
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(invoiceServiceType)="row">
                <div
                  v-for="(service, index) in row.item.invoiceServiceType"
                  :key="service + index"
                >
                  {{ $t(getServiceName(service)) }}
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-danger dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 50px">
                    <li>
                      <button
                        v-if="
                          GET_ACCOUNT_DATA.group_id == 1 ||
                            has_perm('update_register_export_invoice')
                        "
                        class="btn btn-primary btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenEditInput(row)"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                    </li>
                    <li>
                      <button
                        v-if="
                          (GET_ACCOUNT_DATA.group_id == 1 ||
                            has_perm('view_register_export_invoice')) &&
                            onTabSelect === 0
                        "
                        class="btn btn-danger btn-sm"
                        style="margin-left: 6px; margin-top: 5px"
                        @click="onOpenDelete(row)"
                      >
                        <i class="glyphicon glyphicon-remove"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </template>
            </b-table>
            <!-- B-Table End -->
          </div>
        </div>
        <!--  -->
        <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import Paginator from "@/components/Paginator.vue";
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
// import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";
import constants from "@/lib/constantsData";
import Enum from "../../../enum/enum";
import XLSX from "xlsx";
// import sectionselect2 from "@/components/LTESelect2Section";

export default {
  name: "CaseList",
  data() {
    return {
      pkg_tmpl_data: {
        id: 0
      },
      gridDataList: [],
      gridColumns: [],
      userRegisterInvoiceGridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.apartmentCode",
          key: "apartmentCode",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.invoiceServiceType",
          key: "invoiceServiceType",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.companyOrPersonalName",
          key: "companyOrPersonalName",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.address",
          key: "address",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.phone",
          key: "phone",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.email",
          key: "email",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.taxCode",
          key: "taxCode",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.registerDate",
          key: "registerDate",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.user_created",
          key: "userCreated",
          sortable: true,
          class: "text-center "
        },
        { key: "actions", label: "common.action", sortable: false }
      ],
      userRegisterInvoiceCancelGridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.apartmentCode",
          key: "apartmentCode",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.invoiceServiceType",
          key: "invoiceServiceType",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.companyOrPersonalName",
          key: "companyOrPersonalName",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.address",
          key: "address",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.phone",
          key: "phone",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.email",
          key: "email",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.taxCode",
          key: "taxCode",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.registerDate",
          key: "registerDate",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.dateCanceled",
          key: "dateCanceled",
          sortable: true,
          class: "text-center "
        },
        {
          label: "registerExportInvoice.userCanceled",
          key: "userCanceled",
          sortable: true,
          class: "text-center "
        },
        { key: "actions", label: "common.action", sortable: false }
      ],
      serviceList: constants.serviceList,
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "registerExportInvoice.invoiceCancelTitle",
          body: "registerExportInvoice.invoiceCancelContent",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      paginatorItem: {
        commit_function: "GET_REGISTER_EXPORT_INVOICE_LIST"
      },
      search: {
        apartmentCode: "",
        emailOrPhone: "",
        invoiceServiceType: [],
        fromDate: null,
        toDate: null,
        status: [Enum.UserRegisterExportInvoiceStatusEnum.ACTIVATED]
      },
      isLoading: false,
      columnsInvoiceServiceType: {
        data_list: constants.serviceList,
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        isSelectInvoiceStatus: true
      },
      onTabSelect: 0,
      exportExcelData: {
        headerList: [
          [this.$t("registerExportInvoice.apartmentCode")],
          [this.$t("registerExportInvoice.invoiceServiceType")],
          [this.$t("registerExportInvoice.companyOrPersonalName")],
          [this.$t("registerExportInvoice.address")],
          [this.$t("registerExportInvoice.phone")],
          [this.$t("registerExportInvoice.email")],
          [this.$t("registerExportInvoice.taxCode")],
          [this.$t("registerExportInvoice.registerDate")],
          [this.$t("registerExportInvoice.dateCanceled")],
          [this.$t("registerExportInvoice.user_created")],
          [this.$t("registerExportInvoice.userCanceled")]
        ],
        dataList: []
      }
    };
  },
  watch: {
    GET_LANG: function() {
      this.getUserRegisterExportInvoice(1);
    },
    GET_REGISTER_EXPORT_INVOICE_LIST_DATA: function() {
      this.gridDataList = [];
      if (this.onTabSelect === 0) {
        this.gridColumns = this.userRegisterInvoiceGridColumns;
      } else {
        this.gridColumns = this.userRegisterInvoiceCancelGridColumns;
      }
      this.GET_REGISTER_EXPORT_INVOICE_LIST_DATA.forEach((element, i) => {
        let id = element.id;
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let userCreatedLastName = utils.getCleanStringValue(element.user_created.last_name, "");
        let userCreatedFirstName = utils.getCleanStringValue(element.user_created.first_name, "");
        let userCreated = userCreatedLastName + " " + userCreatedFirstName;
        //
        let userCanceledLastName = utils.getCleanStringValue(element.deleted_info.last_name, "");
        let userCanceledFirstName = utils.getCleanStringValue(element.deleted_info.first_name, "");
        let userCanceled = userCanceledLastName + " " + userCanceledFirstName;
        let data = {
          id: id,
          nonumber: nonumber,
          apartmentCode: element.apartment_data.apartment_code,
          invoiceServiceType: element.service_list,
          companyOrPersonalName: element.company_or_personal_name,
          address: element.address,
          phone: element.phone,
          email: element.email,
          taxCode: element.tax_code,
          registerDate: utils.formatSqlDate(element.date_created, null, "HH:mm DD/MM/YYYY"),
          dateCanceled: utils.formatSqlDate(element.deleted_info.date_deleted, null, "HH:mm DD/MM/YYYY"),
          userCreated: userCreated,
          userCanceled: userCanceled
        };
        this.gridDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_REGISTER_EXPORT_INVOICE_LIST_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSearchCase: function() {
      this.getUserRegisterExportInvoice(1);
    },
    onRefsDataSearch: function(data) {
      (this.search.apartmentCode = data.apartmentCode),
        (this.search.emailOrPhone = data.emailOrPhone),
        (this.search.invoiceServiceType = data.invoiceServiceType);
      this.search.toDate = data.toDate;
      this.search.fromDate = data.fromDate;
      this.search.status = data.status;
      this.onTabSelect = data.onTabSelect;
      this.onSearchCase();
    },
    addNew: function() {
      this.$router.push({
        name: "UserRegisterExportInvoiceAdd",
        params: {
          id: 0
        }
      });
    },
    onOpenEditInput: function(row) {
      let id = row.item.id;
      this.$router.push({
        name: "UserRegisterExportInvoiceAdd",
        params: {
          id: id
        }
      });
    },

    onConfirm: function() {
      this.isLoading = true;
      this.isModalVisible = false;
      let data = {
        id: this.originalRecordData.id
      }
      this.DELETE_REGISTER_EXPORT_INVOICE(data)
        .then(
          function() {
            this.isLoading = false;
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridDataList.length == 1
                ? totalPage >= 2
                  ? totalPage - 1
                  : 1
                : currentPage;
            this.getUserRegisterExportInvoice(page);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getUserRegisterExportInvoice(data.params.page)
    },
    closeModal() {
      this.isModalVisible = false;
    },

    onOpenDelete: function(row) {
      this.originalRecordData = row.item;
      this.isModalVisible = true;
    },
    getUserRegisterExportInvoice: function(page) {
      this.isLoading = true;
      let fromDateFormat = "DD/MM/YYYY";
      let filter = {
        params: {
          page: page,
          apartmentCode: this.search.apartmentCode,
          emailOrPhone: this.search.emailOrPhone,
          invoiceServiceType: this.search.invoiceServiceType,
          statusList: this.search.status,
          fromDate: utils.formatSqlUtcStartOfDate(this.search.fromDate, fromDateFormat, "YYYY-MM-DD HH:mm:ss"),
          toDate: utils.formatSqlUtcEndOfDate(this.search.toDate, fromDateFormat, "YYYY-MM-DD HH:mm:ss")
        }
      };
      this.GET_REGISTER_EXPORT_INVOICE_LIST(filter).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    getServiceName: function(value) {
      let index = this.serviceList.findIndex(x => x.id === value);
      return index != -1 ? this.serviceList[index].text : "";
    },
    onSelectServiceType: function(data) {
      if (this.search.invoiceServiceType.indexOf(parseInt(data.id)) == -1) {
        this.search.invoiceServiceType.push(parseInt(data.id));
      }
    },
    onUnselectServiceType: function(data) {
      if (this.search.invoiceServiceType.indexOf(parseInt(data.id)) != -1) {
        this.search.invoiceServiceType.splice(
          this.search.invoiceServiceType.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    // export excel
    getServiceNameFromList: function(serviceList) {
      let resultList = "";
      serviceList.forEach((x, index) => {
        let serviceName = this.getServiceName(x);
        if (serviceName !== "") {
          resultList =
            resultList +
            `${this.$t(serviceName)}${
              index < serviceList.length - 1 ? ", " : ""
            }`;
        }
      });
      return resultList;
    },
    exportExcel: function() {
      this.isLoading = true;
      let fromDateFormat = "DD/MM/YYYY";
      let filter = {
        params: {
          apartmentCode: this.search.apartmentCode,
          emailOrPhone: this.search.emailOrPhone,
          invoiceServiceType: this.search.invoiceServiceType,
          statusList: this.search.status,
          fromDate: utils.formatSqlUtcStartOfDate(this.search.fromDate, fromDateFormat, "YYYY-MM-DD HH:mm:ss"),
          toDate: utils.formatSqlUtcEndOfDate(this.search.toDate, fromDateFormat, "YYYY-MM-DD HH:mm:ss")
        }
      };
      this.GET_REGISTER_EXPORT_INVOICE_LIST(filter)
        .then(
          async function(res) {
            this.isLoading = false;
            let dataList = this.getDataExcelJson(
              this.exportExcelData.headerList,
              res
            );
            await this.createAssetExcelFile(dataList);
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    getDataExcelJson: function(headerList, dataList) {
      let resultList = [];
      //
      [this.$t("registerExportInvoice.apartmentCode")],
        [this.$t("registerExportInvoice.invoiceServiceType")],
        [this.$t("registerExportInvoice.companyOrPersonalName")],
        [this.$t("registerExportInvoice.address")],
        [this.$t("registerExportInvoice.phone")],
        [this.$t("registerExportInvoice.email")],
        [this.$t("registerExportInvoice.taxCode")],
        [this.$t("registerExportInvoice.registerDate")],
        [this.$t("registerExportInvoice.dateCanceled")],
        [this.$t("registerExportInvoice.user_created")],
        [this.$t("registerExportInvoice.userCanceled")];
      // let headerListLength = headerList.length
      let apartmentCodeHeader = headerList[0];
      let invoiceServiceTypeHeader = headerList[1];
      let companyOrPersonalNameHeader = headerList[2];
      let addressHeader = headerList[3];
      let phoneHeader = headerList[4];
      let emailHeader = headerList[5];
      let taxCodeHeader = headerList[6];
      let registerDateHeader = headerList[7];
      let dateCanceledHeader = headerList[8];
      let userCreatedHeader = headerList[9];
      let userCanceledHeader = headerList[10];
      dataList.forEach(data => {
        //
        let userCreatedLastName = utils.getCleanStringValue(data.user_created.last_name, "");
        let userCreatedFirstName = utils.getCleanStringValue(data.user_created.first_name, "");
        let userCreated = userCreatedLastName + " " + userCreatedFirstName;
        //
        let userCanceledLastName = utils.getCleanStringValue(data.deleted_info.last_name, "");
        let userCanceledFirstName = utils.getCleanStringValue(data.deleted_info.first_name, "");
        let userCanceled = userCanceledLastName + " " + userCanceledFirstName;
        //
        let item = {
          [apartmentCodeHeader]: data.apartment_data.apartment_code,
          [invoiceServiceTypeHeader]: this.getServiceNameFromList(data.service_list),
          [companyOrPersonalNameHeader]: data.company_or_personal_name,
          [addressHeader]: data.address,
          [phoneHeader]: data.phone,
          [emailHeader]: data.email,
          [taxCodeHeader]: data.tax_code,
          [registerDateHeader]: utils.formatSqlDate(data.date_created, null, "HH:mm DD/MM/YYYY")
          // [dateCanceledHeader]: utils.formatSqlDate(data.deleted_info.date_deleted, null, "HH:mm DD/MM/YYYY"),
          // [userCreatedHeader]: userCreated,
          // [userCanceledHeader]: userCanceled
        };
        if (this.onTabSelect === 0) {
          item[userCreatedHeader] = userCreated;
        } else {
          (item[dateCanceledHeader] = utils.formatSqlDate(data.deleted_info.date_deleted, null, "HH:mm DD/MM/YYYY")),
            (item[userCanceledHeader] = userCanceled);
        }
        resultList.push(item);
      });
      return resultList;
    },
    createAssetExcelFile: function(jsonData) {
      let data_list = [];

      data_list = jsonData;
      // export json to Worksheet of Excel
      // only array possible
      var assetFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, assetFile, "registerExportInvoiceList"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "RegisterExportInvoiceList.xlsx"); // name of the file is 'book.xlsx'
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "DELETE_REGISTER_EXPORT_INVOICE",
      "GET_REGISTER_EXPORT_INVOICE_LIST"
    ])
  },
  mounted() {
    this.getUserRegisterExportInvoice(1);
    this.gridColumns = this.userRegisterInvoiceGridColumns;
  },

  components: {
    "lte-button": LTEButton,
    // "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading
    // "lte-section-select2": sectionselect2,
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Invoice/UserRegisterExportInvoice.vue